module.exports = {"440981002":"石仔岭街道","440981003":"山美街道","440981006":"金山街道","440981007":"潘州街道","440981008":"宝光街道","440981100":"谢鸡镇","440981101":"新垌镇","440981102":"云潭镇","440981103":"分界镇","440981104":"根子镇","440981105":"泗水镇","440981107":"镇江镇","440981109":"沙田镇","440981110":"南塘镇","440981111":"荷花镇","440981112":"石板镇","440981115":"大井镇","440981116":"潭头镇","440981119":"大坡镇","440981120":"平山镇","440981121":"深镇镇","440981122":"马贵镇","440981123":"古丁镇","440981124":"曹江镇","440981126":"荷塘镇","440981127":"石鼓镇","440981128":"东岸镇","440981129":"长坡镇","440981450":"团结农场","440981451":"胜利农场","440981452":"火星农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440981.json
// module id = 2134
// module chunks = 0